module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/sp/fv_base_2c9b5bd79ad2b5ac522c9fa68e21c4bc.png";